<div class="message-page-container">
  <div class="message-page-message">
    @if (talent) {
    <div>
        @if (countryId === countries.JP) {
          <h3>{{talent.lastName}} {{"talent-happy-path.quick-apply.welcome-page.title" | translate}}</h3>
        }
        @else {
          <h3>{{"talent-happy-path.quick-apply.welcome-page.title" | translate}} {{talent.preferredName}}</h3>
        }
        @if (talent.statusOnOrder === talentStatus.TALENT_APPLIED_ONLINE && countryId != countries.JP) {
          <p>{{"talent-happy-path.quick-apply.welcome-page.continue-message" | translate}}</p>
        }
        @else {
          <p>{{"talent-happy-path.quick-apply.welcome-page.job-board-message" | translate}}</p>
        }
    </div>
    }
  </div>
  @if (talent.statusOnOrder === talentStatus.TALENT_APPLIED_ONLINE && countryId != countries.JP) {
  <a id="welcome-back-continue-button" mat-flat-button color="primary" class="custom-button single-custom-button message-page-button" (click)="navigateToInterviewPage()" >{{"talent-happy-path.quick-apply.continue" | translate}}</a>
  }
  @else {
  <a id="welcome-back-job-board-button" mat-flat-button color="primary" class="custom-button single-custom-button message-page-button" [href]="jobBoardUrl" >{{"talent-happy-path.quick-apply.welcome-page.job-board-button" | translate}}</a>
  }
</div>
